/**
 * Subscription — the pricing section wrapper.
 *
 * Renders the (now backend-wired + Enterprise-aware) SubscriptionPlan.
 * Copy refreshed to set up the 4-tier story including the no-price
 * Enterprise card.
 */
import { motion } from "framer-motion";
import Star from "@/assets/star.svg";
import backgroundSvg from "@/assets/background.svg";
import SubscriptionPlan from "../subscription/SubscriptionPlan";

const Subscription = () => {
  return (
    <div className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img
          src={backgroundSvg}
          alt="Background Pattern"
          className="h-full w-full object-cover"
        />
      </div>
      <section id="pricing" className="py-20">
        <div className="container mx-auto px-4 lg:px-16 flex flex-col gap-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-center flex flex-col gap-4 items-center"
          >
            <div className="border-2 border-[#4CAF50] text-[#4CAF50] bg-[#4CAF50]/20 rounded-full px-4 py-2 flex items-center gap-2 w-fit">
              <img src={Star} alt="star" />
              <p className="text-sm font-medium tracking-wide">PRICING</p>
            </div>
            <div className="flex flex-col gap-4 w-full text-center max-w-2xl">
              <h1 className="text-4xl font-semibold md:text-5xl md:font-bold">
                Honest pricing, real value
              </h1>
              <p className="text-base md:text-xl text-gray-600">
                Every plan includes real double-entry accounting, mobile money
                and tax-ready reports, priced in your own currency. Try any
                plan free for 7 days, no payment needed.
              </p>
              <p className="text-sm text-gray-500">
                No fees on cash or mobile money you record yourself. Payments
                you take through Eaze (mobile money prompts, payment links) are
                paid straight to your account, less 1% and the payment processing fee.
              </p>
            </div>
          </motion.div>

          <SubscriptionPlan />
        </div>
      </section>
    </div>
  );
};

export default Subscription;
